module.exports = __webpack_public_path__ + "static/media/santa.09188781.jpg";